export enum PaymentOption {
  NORMAL = "NORMAL",
  PAYMENT_ON_DELIVERY = "PAYMENT_ON_DELIVERY",
}
